import { render, staticRenderFns } from "./PersonalRealName.vue?vue&type=template&id=4c1ca11f&scoped=true&"
import script from "./PersonalRealName.vue?vue&type=script&lang=js&"
export * from "./PersonalRealName.vue?vue&type=script&lang=js&"
import style0 from "./PersonalRealName.vue?vue&type=style&index=0&id=4c1ca11f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ca11f",
  null
  
)

export default component.exports